import { Card, CardBody, CardFooter, Col } from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { FEATURED_DATA } from "../../../Data/Faq";
import { H3, Image, P } from "../../../AbstractElements";
import FaqProductHover from "./FaqProductHover";
import { dynamicImage } from "../../../Service/DynamicImage";

const FaqFeaturesTutorial = () => {
  return (
    <>
      {FEATURED_DATA.map((item, id) => (
        <Col xl="3" md="6" className="box-col-3" key={id}>
          <Card className="features-faq product-box">
            <div className="faq-image product-img">
              <Image width="345" height="265" alt="feature" className="img-fluid" src={dynamicImage(`${item.img}`)} />
              <FaqProductHover />
            </div>
            <CardBody>
              <H3 className="font-primary mb-1">{item.title}</H3>
              <P>{item.short_description}</P>
            </CardBody>
            <CardFooter className="d-flex align-items-center justify-content-between">
              <span>{item.date}</span>
              <Rating fillColor="#33BFBF" initialValue={Math.random() * 5} size={14} />
            </CardFooter>
          </Card>
        </Col>
      ))}
    </>
  );
};
export default FaqFeaturesTutorial;
